module.exports = __webpack_public_path__ + "static/media/Screenshot 2026-01-31 101353.7d4a08c8.png";